<template>
  <div class="photo-gallery__thumbs" ref="galleryList" :class="{'isModal': isModal}">
    <div
      v-if="overview360Info"
      class="photo-gallery__thumb photo-gallery__thumb--360"
      :class="{'photo-gallery__thumb--360-active': is360Overview}"
      @click="showOverview"
      ref="thumb360">
      <svg width="36"
           height="15"
           viewBox="0 0 36 15"
           fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.76775 5.62084C2.30085 6.55532 0.817871 7.75538 0.817871 9.06425C0.817871 12.0453 8.5105 14.4619 17.9998 14.4619C27.4892 14.4619 35.1818 12.0453 35.1818 9.06425C35.1818 7.84518 33.8954 6.72051 31.7257 5.81689V7.65721C32.1718 7.87515 32.5402 8.09517 32.8306 8.31089C33.156 8.55258 33.3355 8.75356 33.4261 8.89267C33.4694 8.95905 33.4879 9.00446 33.4958 9.02874C33.5031 9.05132 33.5031 9.06141 33.5031 9.06425C33.5031 9.06709 33.5031 9.07717 33.4958 9.09976C33.4879 9.12404 33.4694 9.16945 33.4261 9.23582C33.3355 9.37494 33.156 9.57592 32.8306 9.81761C32.1709 10.3076 31.1091 10.8199 29.6462 11.2794C26.7403 12.1923 22.6223 12.7832 17.9998 12.7832C13.3773 12.7832 9.25943 12.1923 6.35347 11.2794C4.89059 10.8199 3.82882 10.3076 3.16905 9.81761C2.84364 9.57592 2.66417 9.37494 2.57355 9.23582C2.53032 9.16945 2.51174 9.12404 2.50389 9.09976C2.49659 9.07717 2.49657 9.06709 2.49657 9.06425C2.49657 9.06141 2.49659 9.05132 2.50389 9.02874C2.51174 9.00446 2.53032 8.95905 2.57355 8.89267C2.66417 8.75356 2.84364 8.55258 3.16905 8.31089C3.5605 8.02015 4.09346 7.72159 4.76775 7.43086V5.62084Z"
              fill="#4C4C4C"/>
        <path d="M13.2498 5.596C13.2498 6.39598 12.9518 7.06127 12.3559 7.59187C11.7682 8.12247 11.0498 8.38777 10.2008 8.38777C9.5478 8.38777 8.96414 8.22451 8.44987 7.89799C7.93559 7.57147 7.53968 7.1225 7.26214 6.55108L8.41313 5.74294C8.66619 6.1266 8.92741 6.40823 9.19679 6.58781C9.47433 6.7674 9.79269 6.8572 10.1519 6.8572C10.5682 6.8572 10.907 6.74699 11.1682 6.52659C11.4294 6.29802 11.56 5.99191 11.56 5.60824C11.56 5.23274 11.4171 4.94703 11.1314 4.75112C10.8539 4.54704 10.4457 4.445 9.90698 4.445H8.89067V4.01644L10.5804 1.65323H7.88661V0.159387H13.0906V0.600193L11.3029 3.12259C11.8416 3.26136 12.3028 3.55115 12.6865 3.99195C13.062 4.41643 13.2498 4.95112 13.2498 5.596Z" fill="#4C4C4C"/>
        <path d="M20.2148 5.49804C20.2148 6.31435 19.921 7.00005 19.3332 7.55514C18.7455 8.11023 18.0475 8.38777 17.2394 8.38777C16.4476 8.4041 15.7496 8.12655 15.1456 7.55514C14.5497 6.98372 14.2599 6.29394 14.2762 5.4858C14.2762 5.18376 14.3211 4.88989 14.4109 4.60419C14.5415 4.21236 14.8639 3.66135 15.3782 2.95116L17.3986 0.159387H19.3455L17.4843 2.75525H17.5333C18.2271 2.73892 18.8516 3.00422 19.4067 3.55115C19.9618 4.08991 20.2312 4.73888 20.2148 5.49804ZM18.1822 6.47761C18.4435 6.21639 18.5741 5.88987 18.5741 5.49804C18.5741 5.10621 18.4435 4.78377 18.1822 4.53072C17.9292 4.2695 17.6149 4.13889 17.2394 4.13889C16.8639 4.13889 16.5455 4.2695 16.2843 4.53072C16.0313 4.79194 15.9047 5.11438 15.9047 5.49804C15.9047 5.88171 16.0313 6.20823 16.2843 6.47761C16.5455 6.73883 16.8639 6.86944 17.2394 6.86944C17.6149 6.86944 17.9292 6.73883 18.1822 6.47761Z" fill="#4C4C4C"/>
        <path d="M21.36 4.13889C21.36 2.8981 21.6335 1.9022 22.1804 1.1512C22.7273 0.392035 23.5232 0.0124512 24.5681 0.0124512C25.613 0.0124512 26.4048 0.392035 26.9436 1.1512C27.4905 1.9022 27.7639 2.8981 27.7639 4.13889C27.7639 5.38784 27.4864 6.40823 26.9313 7.20005C26.3762 7.99186 25.5885 8.38777 24.5681 8.38777C23.5395 8.38777 22.7477 7.99186 22.1926 7.20005C21.6376 6.40823 21.36 5.38784 21.36 4.13889ZM26.0619 4.15113C26.0619 2.4124 25.564 1.54303 24.5681 1.54303C23.564 1.54303 23.062 2.4124 23.062 4.15113C23.062 5.95518 23.564 6.8572 24.5681 6.8572C25.564 6.8572 26.0619 5.95518 26.0619 4.15113Z" fill="#4C4C4C"/>
        <path d="M29.3039 3.23279C28.9284 2.85729 28.7406 2.4124 28.7406 1.89812C28.7406 1.38385 28.9284 0.943043 29.3039 0.575704C29.6794 0.200202 30.1324 0.0124512 30.663 0.0124512C31.1936 0.0124512 31.6426 0.196121 32.01 0.563459C32.3855 0.930798 32.5732 1.37569 32.5732 1.89812C32.5732 2.42056 32.3855 2.86545 32.01 3.23279C31.6426 3.60013 31.1936 3.7838 30.663 3.7838C30.1324 3.7838 29.6794 3.60013 29.3039 3.23279ZM31.4834 1.91037C31.4834 1.67364 31.4059 1.47772 31.2508 1.32263C31.0957 1.15936 30.8998 1.07773 30.663 1.07773C30.4263 1.07773 30.2304 1.15936 30.0753 1.32263C29.9202 1.47772 29.8427 1.67364 29.8427 1.91037C29.8427 2.13893 29.9202 2.33485 30.0753 2.49811C30.2304 2.65321 30.4263 2.73076 30.663 2.73076C30.8998 2.73076 31.0957 2.65321 31.2508 2.49811C31.4059 2.33485 31.4834 2.13893 31.4834 1.91037Z" fill="#4C4C4C"/>
      </svg>
    </div>
    <div
      class="photo-gallery__thumb"
      :ref="'ref' + i"
      :class="{ 'active': currentPhotoIndex === i && !is360Overview, 'photo-gallery__thumb--video': item.video_id }"
      v-for="(item, i) in photosForRender"
      @mouseenter="timeOutSetSlide($event.target, i)"
      @mouseleave="handleClearTimeout"
      @click="handleClick($event.target, i)"
      :key="i">
      <div
        v-if="item.video_id"
        :style="{backgroundImage: `url(https://img.youtube.com/vi/${item.video_id}/sddefault.jpg)`}"
        class="swiper-lazy video-item__img"></div>
      <div v-if="item.video_id" class="play-video-btn"></div>
      <img
        v-else
        class="photo-gallery__thumb-img"
        :src="item.thumb_photo"
        :alt="productTitle + ' фото-' + i + 1"/>
    </div>
    <span v-if="photoOffset > 0 && !isModal" class="photo-gallery__pseudo-link" @click="openPhotoModal">
      {{ $t('product_show_more') }} {{ photoOffset }}
    </span>
    <span v-if="videos.length && !isModal" class="photo-gallery__pseudo-link photo-gallery__pseudo-link--video" @click="setActiveTab('videos')">
      <span class="play-video-btn play-video-btn--not-absolute"></span>
      {{ $t('tab.video') }}
    </span>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { isAdaptiveMode } from '@/mixins'

export default {
  name: 'PhotoThumbs',
  mixins: [isAdaptiveMode],
  props: {
    isModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      timeout: null,
      isHoverNavbar: false,
      prevIndex: null
    }
  },
  computed: {
    ...mapState({
      photos: state => state.productInfo.productInfo.photos,
      shortPhotoList: state => state.productInfo.productInfo.shortPhotoList,
      photoOffset: state => state.productInfo.productInfo.photoOffset,
      productTitle: state => state.productInfo.productInfo.title,
      currentPhotoIndex: state => state.productGallery.currentPhotoIndex,
      is360Overview: state => state.productGallery.is360Overview,
      videos: state => state.productInfo.productInfo.videos,
      overview360Info: state => state.productGallery.overview360
    }),
    photosForRender () {
      // Вовзращает список изображений для навигационной панели слайдера
      if (!this.isModal) {
        // Если компонент не в модалке, возвращается укороченый список
        return this.shortPhotoList
      }

      return [...this.photos, ...this.videos]
    }
  },
  methods: {
    ...mapActions(['CHANGE_MAIN_PHOTO_INDEX', 'SET_360_OVERVIEW_ACTION', 'CHANGE_CURRENT_VIDEO_INFO', 'SET_ACTIVE_TAB']),
    setActiveTab (name) {
      const data = {
        string: name,
        top: this.isAdaptiveMode ? this.initialOffset - 40 : this.initialOffset
      }

      this.SET_ACTIVE_TAB(data)
    },
    openPhotoModal () {
      this.$modal.show('photo-modal')
    },
    setActiveItem (i) {
      this.CHANGE_MAIN_PHOTO_INDEX(i)
    },
    showOverview () {
      this.SET_360_OVERVIEW_ACTION(true)
      this.$modal.show('photo-modal')
    },
    timeOutSetSlide (e, i) {
      clearTimeout(this.timeout)
      // Добавляет флаг что переход был с помощью ховера на навбар, для отмены скролла к текущему превью
      this.isHoverNavbar = true
      // Добавляет задержку на переход к слайду при наведении на превью в навбаре
      this.timeout = setTimeout(() => {
        this.scrollToElement(e, i)
        this.CHANGE_MAIN_PHOTO_INDEX(i)
      }, 1500)
    },
    handleClearTimeout () {
      this.isHoverNavbar = false
      clearTimeout(this.timeout)
    },
    handleClick (e, i) {
      clearTimeout(this.timeout)
      if (this.isModal) {
        this.scrollToElement(e, i)
      }
      this.CHANGE_MAIN_PHOTO_INDEX(i)
    },
    scrollToElement (e, i) {
      const target = e.tagName === 'IMG' ? e.parentElement : e

      // Скроллит блок с минифото на 1 позицию при выборе последнего или первого элемента во вьюпорте
      if (!this.shouldScrollNavbar(target)) return
      if (i === 1 || (i === 0 && !this.overview360Info)) {
        // Скролл к первому элементу
        this.$refs['ref0'][0].scrollIntoView({ block: 'start' })
      } else if (i === this.photosForRender.length - 2 || i === this.photosForRender.length - 1) {
        // Скролл к последнему элементу
        this.$refs['ref' + (this.photosForRender.length - 1)][0].scrollIntoView({ block: 'start' })
      } else if (i > this.prevIndex && i < this.photosForRender.length - 1) {
        // Скролл к следующему элементу
        this.$refs['ref' + (i + 1)][0].scrollIntoView({ block: 'end' })
      } else if (i < this.prevIndex && i > 0) {
        // Скролл к предыдущему элементу
        this.$refs['ref' + (i - 1)][0].scrollIntoView({ block: 'start' })
      } else if (i === 0 && this.overview360Info) {
        // Скролл к 360
        this.$refs.thumb360.scrollIntoView({ block: 'start' })
      } else if (i === this.prevIndex) {
        // Скролл при повторном нажатии на элемент
        const direction = window.innerWidth < 1100 ? 'x' : 'y'

        const scrollValue = window.innerWidth < 1100 ? this.$refs.galleryList.scrollLeft : this.$refs.galleryList.parentElement.scrollTop
        const offsetTop = target.getBoundingClientRect()[direction] - this.$refs.galleryList.getBoundingClientRect()[direction] - (window.innerWidth < 1100 ? 0 : scrollValue)
        const galleryHeight = window.innerWidth < 1100 ? this.$refs.galleryList.parentElement.clientWidth : this.$refs.galleryList.parentElement.clientHeight
        if (offsetTop > galleryHeight / 2) {
          this.$refs['ref' + (i + 1)][0].scrollIntoView({ block: 'end' })
        } else {
          this.$refs['ref' + (i - 1)][0].scrollIntoView({ block: 'start' })
        }
      }
      this.prevIndex = i
    },
    shouldScrollNavbar (target) {
      const direction = window.innerWidth < 1100 ? 'x' : 'y'

      const scrollValue = window.innerWidth < 1100 ? this.$refs.galleryList.scrollLeft : this.$refs.galleryList.parentElement.scrollTop
      const offsetTop = target.getBoundingClientRect()[direction] - this.$refs.galleryList.getBoundingClientRect()[direction] - scrollValue
      const galleryHeight = this.$refs.galleryList.parentElement.clientHeight

      return offsetTop >= galleryHeight - 130 || offsetTop <= 60
    }
  },
  watch: {
    currentPhotoIndex (value, prevValue) {
      if (!this.isModal) return

      const target = this.$refs['ref' + (value)][0]

      if (!this.isHoverNavbar && this.shouldScrollNavbar(target)) {
        // Скроллит к элементу навигационной панели слайдера при изменени слайда
        if (value === 1) {
          this.$refs['ref0'][0].scrollIntoView({ block: 'start' })
        } else if (value === this.photosForRender.length - 2) {
          this.$refs['ref' + (this.photosForRender.length - 1)][0].scrollIntoView({ block: 'start' })
        } else if (value > prevValue && value < this.photosForRender.length) {
          this.$refs['ref' + (value - 1)][0].scrollIntoView(window.innerWidth < 1100 ? { inline: 'start' } : { block: 'start' })
        } else if (value < prevValue && value > 0) {
          this.$refs['ref' + (value + 1)][0].scrollIntoView(window.innerWidth < 1100 ? { inline: 'end' } : { block: 'end' })
        }
      }
      this.isHoverNavbar = false
    }
  }
}
</script>

<style scoped lang="sass">

.photo-gallery__thumbs
  display: none
  flex-direction: row

  +mmin($tablet)
    &:not(.isModal)
      display: flex
      flex-direction: column
      align-items: center

  +mmin(1100)
    &.isModal
      display: flex
      flex-direction: column
      align-items: center
      width: 120px

  &--overview
    border-color: #E7E7E7

.isModal.photo-gallery__thumbs
  display: flex
  overflow: auto
  padding: 0 30px

  .photo-gallery__thumb
    min-width: 60px
    margin-bottom: 10px

    &:not(:last-child)
      margin-right: 10px

      +mmin(1100)
        margin-right: 0

.photo-gallery__thumb
  width: 60px
  cursor: pointer
  border: 1px solid #E7E7E7
  border-radius: 3px
  position: relative
  height: 60px
  display: flex
  align-items: center

  &:not(&--video)
    padding: 1px

  &:not(:last-child)
    margin-bottom: 10px

.photo-gallery__thumb.active:not(.photo-gallery__thumb--video)
  border-color: $main-color

.photo-gallery__thumb.active .video-item__img
  border: 1px solid $main-color

.photo-gallery__thumb-img
  display: block
  width: 100%
  font-size: 0

.photo-gallery__pseudo-link
  position: relative
  margin-top: 10px
  font-size: 14px
  border-bottom: 1px solid $text-color
  cursor: pointer

  &:hover
    border-color: transparent

  &--video
    margin-top: 30px

.photo-gallery__thumb--360
  height: 60px
  display: flex
  justify-content: center
  align-items: center

  &:hover
    border: 1px solid #e7e7e7

  &-active
    border-color: $main-color

.play-video-btn
  width: 25px
  height: 25px
  background-color: $main-color
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.6)
  border-radius: 50%
  position: absolute
  top: 50%
  left: 50%
  transform: translate3d(-50%, -50%, 0)
  transition: all .3s

  &:before
    border-style: solid
    border-width: 6px 0 6px 10px
    content: ''
    position: absolute
    top: 50%
    left: 50%
    transform: translate3d(-50%, -50%, 0)
    border-color: transparent transparent transparent #fff

  &:hover
    background-color: $main-color

  &--not-absolute
    position: relative
    display: block
    transform: none
    top: auto
    left: auto
    margin: 0 auto 5px
    box-shadow: none

    &:before
      border-width: 4px 0 4px 7px
      transform: translate3d(-25%, -50%, 0)

.video-item__img
  width: 60px
  height: 60px
  background-size: cover
  border-radius: 5px

</style>
